/**
 * Main JS file for Nando behaviours
 */

/* globals jQuery */
(function ($) {
  "use strict";

  var $document = $(document);

  $document.ready(function () {

    /**
     * FitVids.js for responsive videos
     */
    var $postContent = $(".post-content");
    $postContent.fitVids();

    $('.js-toggle-nav').on('click', function(event) {
      event.preventDefault();
      $('.js-toggle-nav').toggleClass('open');
      toggleNav();
    });
    // Close dropdowns on outside click
    $(document).on('click touchend', function(event) {
      if ( ! $(event.target).closest('.js-toggle-nav').length && ! $(event.target).closest('.js-main-nav').length && $('body').hasClass('nav-open') ) {
        $('.js-toggle-nav').removeClass('open');
        toggleNav();
      }
    });

    /**
     * Handle sidebar height for phones and tablets
     */
    $(window).on('resize', function() {
      if ( jQuery('body').hasClass('nav-open') ) {
        jQuery('body').css('transform', 'translateY(' + jQuery('.js-main-nav').innerHeight() + 'px)');
      }
    });

  });

})(jQuery);

function toggleNav() {
  var $body = jQuery('body');
  var menu_height = jQuery('.js-main-nav').innerHeight();
  if ( $body.hasClass('nav-open') ) {
    jQuery('body').css('transform', 'translateY(0)');
  } else {
    jQuery('body').css('transform', 'translateY(' + menu_height + 'px)');
  }
  jQuery('body').toggleClass('nav-open');
}

window.addEventListener(
  "load",
  function () {
    // eslint-disable-next-line no-undef
    Lightense(".kg-gallery-image img", {
      padding: 56,
      offset: 20,
      background: "rgba(255, 255, 255, .85)",
    });
  },
  false
);
